import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MemosResult } from "models/memo";

export interface AdminMemosSliceState {
    result: MemosResult | null;
}

export const initialState: AdminMemosSliceState = {
    result: null,
};

const AdminMemosSlice = createSlice({
    name: "admin-memos-slice",
    initialState,
    reducers: {
        setMemos(state, { payload }: PayloadAction<MemosResult>) {
            state.result = payload;
        },
        /** A note was sent: the list reloads next time it is opened. */
        invalidateMemos(state) {
            state.result = null;
        },
    },
});

export const {
    setMemos,
    invalidateMemos,
} = AdminMemosSlice.actions;

export default AdminMemosSlice.reducer;
